// src/services/authService.js
import apiClient from './apiClient';

/* Đăng nhập người dùng */
export const loginUser = async (credentials) => {
  try {
    const response = await apiClient.post('/api/auth/login', {
      username: credentials.username,
      password: credentials.password,
    });
    if (response.data.success) {
      return {
        user: response.data.user,
        token: response.data.token,
      };
    } else {
      throw new Error(response.data.message || 'Đăng nhập thất bại');
    }
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Đăng nhập thất bại');
  }
};

/* Đăng ký người dùng */
export const registerUser = async (userData) => {
  try {
    const response = await apiClient.post('/api/auth/register', userData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Đăng ký thất bại');
  }
};

/* Cập nhật thông tin người dùng */
export const updateUser = async (userData) => {
  try {
    const response = await apiClient.put('/api/user/update', userData);
    if (response.data.success) {
      return response.data.user;
    } else {
      throw new Error(response.data.message || 'Cập nhật thông tin thất bại');
    }
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Cập nhật thông tin thất bại');
  }
};

/**
 * Đổi mật khẩu.
 * @param {number} userId - ID của người dùng
 * @param {object} passwordData - { currentPassword, newPassword }
 * @returns {Promise<void>}
 */
export const changePassword = async (userId, passwordData) => {
  try {
    const response = await apiClient.post('/api/user/change-password', passwordData);
    if (response.data.success) {
      return;
    } else {
      throw new Error(response.data.message || 'Đổi mật khẩu thất bại');
    }
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Đổi mật khẩu thất bại');
  }
};

/* Lấy thông tin người dùng từ token */
export const getUserByToken = async () => {
    const token = localStorage.getItem('jwtToken');
    if (!token) {
        throw new Error('Không có token để lấy thông tin người dùng.');
    }
    try {
        const response = await apiClient.get('/api/userInfo');
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Không thể lấy thông tin người dùng');
    }
};

/**
 * Đăng xuất.
 * @returns {Promise<void>}
 */
export const logoutUser = async () => {
  return Promise.resolve();
};